module.exports = __webpack_public_path__ + "img/29.9ea4dfd1.png";